@if (linked && unlinked) {
    <div class="link-page row" #page>
        <div
            class="linked-items col-6"
            [class.col-12]="!showLinkPanel"
            data-uiid="section-linked-items"
        >
            <div
                class="detail-page-card"
                [class.no-links]="!allowAddNew && !showBatchButton && !showLinkPanel && disabled"
            >
                <div class="detail-page-card-title">
                    {{ 'linkedTitle' | t: { typename: typename } }}
                </div>
                <div class="detail-page-card-actions">
                    @if (allowAddNew) {
                        <button class="btn btn-raised green" (click)="addClicked()">
                            <i class="fas fa-plus-circle"></i>
                            <span>{{
                                'addNewButton'
                                    | t: { singularTypename: singularTypename }
                            }}</span>
                        </button>
                    }
                    @if (showBatchButton) {
                        <button class="btn btn-raised" (click)="batchClicked()">
                            <i class="fas fa-pencil-alt"></i>
                            <span>{{
                                'editLinkedButton' | t: { typename: typename }
                            }}</span>
                        </button>
                    }
                    @if (!disabled && !hidePanelToggle) {
                        <button class="btn btn-raised" (click)="showLinkPanel = !showLinkPanel">
                            <i
                                class="{{
                                    showLinkPanel ? 'fas fa-check-square' : 'far fa-square'
                                }}"
                            ></i>
                            <span
                                >{{
                                    (showLinkPanel
                                        ? 'hideLinkableButton'
                                        : 'showLinkableButton'
                                    ) | t: { typename: typename }
                                }}</span
                            >
                        </button>
                    }
                    @if (allowReload) {
                        <button class="btn btn-raised" (click)="reloadClicked()">
                            <i class="far fa-sync-alt"></i>
                            <span>{{ 'reloadButton' | t }}</span>
                        </button>
                    }
                </div>
                <div class="detail-page-card-body">
                    <ul
                        class="list-group list-group-flush"
                        [sortablejs]="linked"
                        [sortablejsOptions]="sortingOptions"
                    >
                        @for (item of linked; track item) {
                            <li class="list-group-item list-group-item-action py-2">
                                <div class="d-flex w-100 justify-content-between">
                                    <h6
                                        class="text-truncate me-2 mb-0"
                                        [matTooltip]="item[displayValueProp]"
                                    >
                                        @if (
                                            item.linkableDisplayItems &&
                                            item.linkableDisplayItems.length > 0
                                        ) {
                                            <i
                                                (click)="expandItem(item); $event.stopPropagation()"
                                                class="far fa-{{
                                                    item._isExpanded ? 'minus' : 'plus'
                                                }}-square group-expander"
                                            ></i>
                                        }
                                        @if (useIcons) {
                                            <span>
                                                @for (rowIcon of item.rowIcons; track rowIcon) {
                                                    <i class="{{ rowIcon }} ms-2 rowIcon"> </i>
                                                }
                                            </span>
                                        }
                                        <span data-uiid="text-item">
                                            {{ item[displayValueProp] }}
                                        </span>
                                    </h6>
                                    <h6 class="group-item-actions mb-0">
                                        @if (allowOpenItem) {
                                            @if (allowEditItem) {
                                                <i
                                                    class="fas fa-pencil-alt"
                                                    (click)="
                                                        itemDoubleClick(item, false, false);
                                                        $event.stopPropagation()
                                                    "
                                                ></i>
                                            }
                                            <i
                                                class="fas fa-external-link-alt open-item-link ms-2"
                                                [matTooltip]="
                                                    'openInNewTabTooltip' | t
                                                "
                                                (click)="openItem(item); $event.stopPropagation()"
                                                data-uiid="button-open-item"
                                            ></i>
                                        }
                                        @if (!disabled && showLinkPanel) {
                                            <i
                                                (click)="toggleItem(item, false, true)"
                                                class="fas fa-arrow-right ms-2"
                                                data-uiid="button-unlink-item"
                                            ></i>
                                        }
                                    </h6>
                                </div>
                                @if (
                                    item._isExpanded &&
                                    item.linkableDisplayItems &&
                                    item.linkableDisplayItems.length > 0
                                ) {
                                    <div class="item-expand">
                                        <table class="cerrix-table bordered-columns">
                                            <tbody>
                                                @for (
                                                    prop of item.linkableDisplayItems;
                                                    track prop
                                                ) {
                                                    <tr>
                                                        <td>
                                                            <b>{{ prop.Header }}</b>
                                                        </td>
                                                        <td class="text-truncate">
                                                            <workspace-cell
                                                                [configs]="rendererConfig"
                                                                [row]="item.displayItemRow"
                                                                [header]="prop.Header"
                                                            >
                                                            </workspace-cell>
                                                        </td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                }
                            </li>
                        }
                    </ul>
                </div>

                <div class="detail-page-footer text-center">
                    @if (linked.length > 0) {
                        <span>{{
                            'linkedCount'
                                | t: { count: linked.length, typename: typename }
                        }}</span>
                    } @else {
                        <div class="list-empty-text p-1">
                            {{ 'noLinkedItems' | t: { typename: typename } }}
                        </div>
                    }
                </div>
            </div>
        </div>

        <div
            class="linkable-items col-6"
            [hidden]="!showLinkPanel"
            data-uiid="section-linkable-items"
        >
            <div class="detail-page-card">
                <div class="detail-page-card-title">
                    {{ 'linkableTitle' | t: { typename: typename } }}
                </div>
                <div class="detail-page-card-actions">
                    @if (!hideFilter) {
                        <input
                            type="text"
                            class="form-control form-control-sm me-2"
                            [placeholder]="'filterPlaceholder' | t"
                            (debounce-input-event)="quickFilter()"
                            [(ngModel)]="filterText"
                            inputTooltip
                        />
                    }
                    <div class="spacer"></div>
                    @if (showAdvancedFilters) {
                        <button
                            class="btn btn-outline-secondary form-control-sm me-2"
                            (click)="showFilterConfig()"
                            [matTooltip]="'showAdvancedFiltersTooltip' | t"
                        >
                            <i class="fas fa-filters" aria-hidden="true"></i>
                        </button>
                        <button
                            class="btn btn-outline-secondary form-control-sm"
                            [matTooltip]="'clearFiltersTooltip' | t"
                            (click)="clearFilters()"
                        >
                            <i class="fas fa-filter-circle-xmark" aria-hidden="true"></i>
                        </button>
                    }
                </div>
                <div class="detail-page-card-body">
                    <ul
                        class="list-group list-group-flush"
                        [sortablejs]="unlinked"
                        [sortablejsOptions]="sortingOptions"
                    >
                        @for (item of linkablePage; track item) {
                            <li class="list-group-item list-group-item-action py-2">
                                <div class="d-flex w-100 justify-content-between">
                                    <h6
                                        class="text-truncate me-2 mb-0"
                                        [matTooltip]="item[displayValueProp]"
                                    >
                                        <i
                                            class="fas fa-arrow-left me-2"
                                            (click)="toggleItem(item, true, true)"
                                            data-uiid="button-link-item"
                                        ></i>
                                        @if (
                                            item.linkableDisplayItems &&
                                            item.linkableDisplayItems.length > 0
                                        ) {
                                            <i
                                                (click)="expandItem(item); $event.stopPropagation()"
                                                class="far fa-{{
                                                    item._isExpanded ? 'minus' : 'plus'
                                                }}-square group-expander"
                                            ></i>
                                        }
                                        @if (useIcons) {
                                            <span>
                                                @for (rowIcon of item.rowIcons; track rowIcon) {
                                                    <i class="{{ rowIcon }} ms-2 rowIcon"> </i>
                                                }
                                            </span>
                                        }
                                        <span data-uiid="text-item">
                                            {{ item[displayValueProp] }}
                                        </span>
                                    </h6>
                                    @if (allowOpenItem) {
                                        <h6 class="group-item-actions mb-0">
                                            <i
                                                class="fas fa-external-link-alt open-item-link"
                                                [matTooltip]="
                                                    'openInNewTabTooltip' | t
                                                "
                                                (click)="openItem(item); $event.stopPropagation()"
                                                data-uiid="button-open-item"
                                            ></i>
                                        </h6>
                                    }
                                </div>
                                @if (
                                    item._isExpanded &&
                                    item.linkableDisplayItems &&
                                    item.linkableDisplayItems.length > 0
                                ) {
                                    <div class="item-expand">
                                        <table class="cerrix-table bordered-columns">
                                            <tbody>
                                                @for (
                                                    prop of item.linkableDisplayItems;
                                                    track prop
                                                ) {
                                                    <tr>
                                                        <td>
                                                            <b>{{ prop.Header }}</b>
                                                        </td>
                                                        <td class="text-truncate">
                                                            <workspace-cell
                                                                [configs]="rendererConfig"
                                                                [row]="item.displayItemRow"
                                                                [header]="prop.Header"
                                                            >
                                                            </workspace-cell>
                                                        </td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                }
                            </li>
                        }
                    </ul>
                </div>

                <div class="detail-page-footer">
                    @if (!linkablePage || linkablePage.length === 0) {
                        <div class="list-empty-text">
                            @if (unlinked.length > 0) {
                                <span>
                                    {{
                                        'noMatchFilter'
                                            | t: { typename: typename }
                                    }}
                                </span>
                            } @else {
                                <span>
                                    {{
                                        'noItemsToLink'
                                            | t: { typename: typename }
                                    }}
                                </span>
                            }
                        </div>
                    }
                    @if (unlinked.length > 0 && linkablePaginationPageCount > 1) {
                        <div class="pagination justify-content-center">
                            <ul class="pagination">
                                <li
                                    class="page-item"
                                    [class.disabled]="linkablePaginationPage == 0"
                                >
                                    <span
                                        class="page-link"
                                        (click)="setPagination(linkablePaginationPage - 1)"
                                    >
                                        {{ 'previousPage' | t }}
                                    </span>
                                </li>

                                <li class="page-item disabled">
                                    <span class="page-link">{{
                                        'paginationText'
                                            | t: linkablePaginationParams
                                    }}</span>
                                </li>

                                <li
                                    class="page-item"
                                    [class.disabled]="
                                        linkablePaginationPage >= linkablePaginationPageCount - 1
                                    "
                                >
                                    <span
                                        class="page-link"
                                        (click)="setPagination(linkablePaginationPage + 1)"
                                    >
                                        {{ 'nextPage' | t }}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    }
                </div>
            </div>
        </div>

        @if (showAdvancedFilters) {
            <div>
                <workspace-advanced-workspace-config
                    [moduleType]="moduleType"
                    [filterConfig]="filterConfig"
                    [activeFilters]="activeFilters"
                    [NumberProperties]="NumberProperties"
                    [DateProperties]="DateProperties"
                    [allHeaders]="activeHeaders"
                    [headerLookup]="headerLookup"
                    [activeHeaders]="activeHeaders"
                    (ApplyClick)="applyFilters($event)"
                    [showTableConfiguration]="false"
                    #advancedConfigComponent
                >
                </workspace-advanced-workspace-config>
            </div>
        }
    </div>
}
